import { Head, usePage } from "@inertiajs/react";

import { GlobalStyle } from "../../constants/global-style";
import ProvideLoggedInUser from "../../providers/ProvideLoggedInUser";
import WebinarsIndexApp from "../../webinars/index/WebinarsIndexApp";

// Auto-resolved Inertia page for WebinarsController#index when the
// `webinars_index_rebrand_v1` FeatureToggle is ON. When OFF the controller
// redirects to the homepage webinar section (/#webinar) — there is no legacy
// /webinars listing to serve.
//
// Props (from Rails via render_inertia):
//   theme: 'dark' | 'light' — driven by dark_mode_v1.
//   auth_rebrand: boolean — driven by auth_rebrand_v1 (reserved for login
//     redirects; the listing itself is public).
export default function Index() {
  const {
    theme = "light",
    theme_options: themeOptions = [],
    type_name_options: typeNameOptions = [],
  } = usePage().props;

  return (
    <>
      <Head>
        <title>
          Semua Webinar dan Live Online Classes — Taxsam Learning Center
        </title>
        <meta
          name="description"
          content="Katalog lengkap webinar dan live online class pajak Taxsam. Cari, filter berdasarkan status, tipe, tanggal, dan rekaman yang tersedia."
        />
      </Head>
      <GlobalStyle />
      <ProvideLoggedInUser>
        <WebinarsIndexApp
          theme={theme}
          themeOptions={themeOptions}
          typeNameOptions={typeNameOptions}
        />
      </ProvideLoggedInUser>
    </>
  );
}
